module.exports = __webpack_public_path__ + "img/Group 64.4f4022b7.png";